import { z } from "zod";

export default {
  params: z.discriminatedUnion("status", [
    z.object({
      accountId: z.string(),
      status: z.literal("validated"),
    }),
    z.object({
      accountId: z.string(),
      status: z.literal("refused"),
      reason: z.string().trim().min(1),
    }),
  ]),
  response: z.object({
    success: z.boolean(),
  }),
};
